import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { Helmet } from 'react-helmet-async';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const AboutPage = () => {
    const navigate = useNavigate();
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();

    useEffect(() => {
        AOS.init({
            duration: 1000,     // animation duration
            once: false,        // allow animation every time the element is in view
            mirror: true        // animate out while scrolling past
        });
    }, []);



    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>

            <Helmet>
                <title>About Colours Boutique | Saree Boutique for Singapore Buyers</title>
                <meta name="description" content="Learn about Colours Boutique, a saree and ethnic wear destination offering curated Indian silk sarees to Singapore buyers." />
                <link rel="canonical" href="https://coloursboutique.com/about" />
            </Helmet>
            <div className="home-saree-container">

                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('About Colours Boutique')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => navigate("/")}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Colours Boutique')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>




                {/* Training That Transforms Section */}
                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        {/* Section Title */}
                        {/* <h2 className="fw-bold text-center text-bg-light-color">Training That Transform</h2>
                    <p className="text-center px-md-5 mb-4">
                        Our programs go beyond traditional learning by combining cutting-edge strategies,
                        real-world applications, and expert guidance to create lasting impact.
                    </p> */}

                        <div className="row align-items-stretch">
                            {/* Left Side - Image (Full Height) */}
                            <div className="col-md-6 d-flex align-items-stretch left-side-img" data-aos="flip-left"
                                data-aos-easing="ease-out-cubic"
                                data-aos-duration="1000">
                                <img
                                    src="/img/About Us.jpg" 
                                    alt="Training"
                                    className="img-fluid  w-100 h-100 object-fit-cover"
                                />
                            </div>

                            {/* Right Side - List Items (Full Height) */}
                            <div className="col-md-6 text-left  justify-content-between">

                                <div className="aboutpage-content newww" >
                                    <h2 className="fw-bold text-center text-md-start mb-4" style={{ color: "#3a3530" }} data-aos="fade-up" data-aos-delay="200">{translateSync('Colours Boutique')} </h2>

                                    <p data-aos="fade-up" data-aos-delay="200">{translateSync('Welcome to Colours Boutique, where tradition meets elegance. We are dedicated to bringing you the finest collection of sarees and ethnic wear.')}</p>
                                    <p data-aos="fade-up" data-aos-delay="300">{translateSync('Our journey began with a passion for preserving the rich heritage of Indian handlooms. Each piece in our collection is a testament to the skill and artistry of our weavers.')}</p>
                                    <p data-aos="fade-up" data-aos-delay="400">{translateSync('We strive to offer:')}</p>
                                    <ul data-aos="fade-down" data-aos-delay="500">
                                        <li>{translateSync('Authentic and high-quality handloom sarees')}</li>
                                        <li>{translateSync('A curated selection of contemporary and traditional designs')}</li>
                                        <li>{translateSync('An exceptional shopping experience for our customers')}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>




                        <div className="row align-items-stretch mt-5">
                            {/* Left Side - Image (Full Height) */}
                            {/* <div className="col-md-6 ">
                                <div className="vision-statement">
                                    <img
                                        src="/img/glasses.png"
                                        alt="Training"
                                        className="img-fluid  iconabt-img"
                                        data-aos="zoom-in" data-aos-delay="200"
                                    />
                                    <h5 data-aos="zoom-in" data-aos-delay="200">{translateSync('Vision Statement')}</h5>
                                    <p data-aos="fade-up" data-aos-delay="200">{translateSync('To be the preferred destination for authentic and elegant ethnic wear globally.')}</p>
                                </div>
                            </div> */}

                            {/* Right Side - List Items (Full Height) */}
                            {/* <div className="col-md-6 ">
                                <div className="vision-statement">
                                    <img
                                        src="/img/Goall.png"
                                        alt="Training"
                                        className="img-fluid  iconabt-img"
                                        data-aos="zoom-in" data-aos-delay="200"
                                    />
                                    <h5 data-aos="zoom-in" data-aos-delay="200">{translateSync('Mission Statement')}</h5>
                                    <p data-aos="fade-up" data-aos-delay="200">{translateSync('To empower weavers and delight customers with timeless fashion.')}</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>






                {/* Certifications */}

                <section className="certifications-section mt-0 webview">
                    <div className="container d-flex align-items-center justify-content-between rounded" >
                        {/* <div className="col-md-6 text-white text-align-left certificad-left-column">
                            <h2 className="fw-bold" >Our Certification</h2>
                            <p >We offer internationally recognized and industry-approved training to ensure high-quality education.</p>
                        </div>

                        <div
                            className="col-md-6 d-flex bg-white p-3 rounded justify-content-center align-items-center certificad-right-column"
                        >
                            <div className="col-md-5 text-center">
                                <img src="/img/dubai-img.png" className="img-fluid" alt="Dubai Knowledge" />
                            </div>
                            <div className="border-start mx-3" style={{ height: "50px" }}></div>
                            <div className="col-md-5 text-center">
                                <img src="/img/crd-certified.png" className="img-fluid" alt="CPD Certified" />
                            </div>
                        </div> */}
                        {/* <div className="container my-5">
                            <div className="cta-box p-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
                                <div>
                                    <p data-aos="fade-right" data-aos-delay="200">{translateSync('Experience the elegance of Colours Boutique')}</p>

                                    <h3 className="mb-1 fw-bold" data-aos="fade-right" data-aos-delay="300">{translateSync('Explore our collection today?')}</h3>
                                </div>
                                <p data-aos="fade-left" data-aos-delay="200" style={{ cursor: "pointer" }} onClick={() => navigate("/contact")} className="  px-4 py-2 mt-3 mt-md-0 fw-semibold">
                                    <button class="rbt-btn btn-gradient rbt-switch-btn rbt-switch-y mt-3"><span data-text={translateSync("Let’s Connect")}>{translateSync('Let’s Connect')}➔</span></button>

                                </p>
                            </div>
                        </div> */}
                    </div>
                </section>


            </div>

        </>
    )
}

export default AboutPage;